@if (loaderIcon | async) {
  <app-loader [isPaymentRefund]="true" [initiatedVoidCC]="initiatedVoidCC"
    [showPaymentMessage]="showLoaderMesage" [retryTransactionStatus]="retryTransactionStatusLoader"
  [isTDEmv]="isTDEmv" [stripeLoader] ="stripeLoader" (emitPaymentTerminalStatus)="emitPaymentTerminalStatus($event)"></app-loader>
}
@if (isLoaderActive ) {
  <app-loader></app-loader>
}
@if (loaderIcon2 | async) {
  <app-unitInfoLoader></app-unitInfoLoader>
}
<!-- Start Payment Section -->
@if (showPage) {
  <div class="Rentalpayment customer_rental">
    <div class="row mx-0 w-100" style="margin-top: -22px;">
      <app-call-script [section]="section" style="width: 100%;"></app-call-script>
    </div>
    <div class="row justify-content-center mx-0 mt-1">
      <div class="paymentTable-container NoSidePadding">
        <h5>Payments</h5>
        @if (!merchSaleSection) {
          <div class="d-flex justify-content-center align-items-center payment_qty_sec mb-3"
            >
            <a class="pay_minus" (click)="removeRow()" [class.disabled]="paymentProcessing || isTdMismatchRetryBlocked"
              [attr.aria-disabled]="paymentProcessing || isTdMismatchRetryBlocked ? 'true' : null"><i
            class="fa fa-minus"></i></a>
            <input type="text" [(ngModel)]="paymentCount" readonly>
            <a class="pay_pluse" (click)="addRow()" [class.disabled]="paymentProcessing || isTdMismatchRetryBlocked || isAnyRowSurchargeLocked()"
              [attr.aria-disabled]="paymentProcessing || isTdMismatchRetryBlocked || isAnyRowSurchargeLocked() ? 'true' : null"
              [attr.tabindex]="isAnyRowSurchargeLocked() ? '0' : null"
              [attr.aria-describedby]="isAnyRowSurchargeLocked() ? 'surchargeLockReason-addRow' : null"
              (keydown)="isAnyRowSurchargeLocked() ? onLockedFieldKeydown($event) : null"><i
            class="fa fa-plus"></i></a>
            @if (isAnyRowSurchargeLocked()) {
              <span id="surchargeLockReason-addRow" class="visually-hidden">{{surchargeLockReasonText}}</span>
            }
          </div>
        }
        @if (merchSaleSection) {
          <div class="d-flex justify-content-center align-items-center">
            <select class="form-select" (change)="onChangeMerchSection()">
              <option value="0">Select</option>
              @for (item of sectionList; track item) {
                <option [value]="item.sectionList.Id">{{item.SectionName}}</option>
              }
            </select>
          </div>
        }
        @if (processPayment.Type === 5) {
          <div class="d-flex justify-content-center align-items-center" style="margin-bottom: 15px;">
            <h3 class="text-center pay_store_name">{{processPayment.facilityName}}</h3>
          </div>
        }
        <div class="d-flex justify-content-between payment_tot_amt mt-1 position-relative">
          @if (isDisplayCharitable &&
            (processPayment.Type == 2 || this.processPayment.Type == 6 || this.processPayment.Type == 5 || this.processPayment.Type == 7)) {
            <div
              >
              <div class="checkbox_pos">
                @if (paymentSetting.FixedCharityAmount) {
                  <div>
                    <label class="pure-material-checkbox">
                      <input class="checkBoxClass" type="checkbox" [(ngModel)]="isFixedCharityAmount"
                        (change)="calculateContribution()">
                        <span> </span>
                      </label>
                      <div class="d-inline-flex px-0 align-items-center">
                        <span class="charitypay_text mt-0">Contribute &nbsp; </span>
                        <ejs-numerictextbox [showSpinButton]="false" format="c2" maxlength="7" min='0'
                          max='9999.99' class="numerictextbox"
                          [readonly]="!isOverrideCharityAmount || !isFixedCharityAmount"
                          [(value)]="charityAmount" (change)="calculateContribution()"
                          (blur)="onBlurNumericTextBox($event)">
                        </ejs-numerictextbox>
                        <span class="charitypay_text mt-0"> &nbsp; to Charity</span>
                      </div>
                    </div>
                  }
                  @if (paymentSetting.RoundUpCharityAmount) {
                    <div class="mt-2">
                      <label class="pure-material-checkbox float-start">
                        <input type="checkbox" class="checkBoxClass" [(ngModel)]="isRoundUpCharityAmount"
                          (change)="calculateContribution()">
                          <span class="charitypay_text mt-0">Round Up Total Amount to Contribute
                          {{roundUpValueDisplay | currency}} to Charity</span>
                        </label>
                      </div>
                    }
                  </div>
                </div>
              }
              <p class="totalamt_pos">Total Amount: {{isAnyRowSurchargeLocked() ? (originalTotalAmount | currency) : (totalAmount | currency)}}</p>
            </div>
            <div class="scroll_outer">
              <div class="scroll_inner_payment">
                <div class="normal_table" [class.disabledPayment]="merchSaleSection">
                  <table class="table table-hover bg-white mb-0 table-fixed">
                    <thead>
                      <tr>
                        <th style="width: 96px;">Payment</th>
                        <th style="width: 96px;">Tender</th>
                        <th style="width: 155px;">Amount</th>
                        @if (isAnyRowSurchargeLocked()) {
                          <th style="width: 110px;">Fee</th>
                          <th style="width: 110px;">Sub Total</th>
                        }
                      </tr>
                    </thead>
                  </table>
                  <div id="PaymentScroll" class="overflow-auto">
                    <table class="table table-hover bg-white mb-0 table-fixed">
                      <tbody>
                        @for (drow of paymentTable; track drow) {
                          <tr [class.disabledPayedRow]="drow.payComplete">
                            <td style="width: 100px;" class="align-middle">{{drow.payName}}</td>
                            <td style="width: 100px;">
                              <select class="form-select form-select-sm custom-select"
                                [attr.data-surcharge-row-id]="drow.payId"
                                (change)="onChangePayMode($event, drow.payId)">
                                @for (item of payModes; track item) {
                                  <option [value]="item.PaymentModeId"
                                    [disabled]="isPaymentModesDisabled(item.PaymentModeId, drow.payId)"
                                    [selected]="item.PaymentModeId == drow.defaultmode">
                                    {{item.PaymentModeName}}
                                  </option>
                                }
                              </select>
                            </td>
                            <td style="width: 155px;">
                              <div class="d-flex justify-content-between">
                                <input type="text" step="0.01" [value]="drow.payAmount | currency"
                                  [ngModel]="drow.payAmount | currency"
                                  [appTwoDigitDecimal]='costValueDirectiveSetting'
                                  (blur)="onAmountBlur(drow, $event)"
                                  (keypress)="numberOnly($event)"
                                  (keydown)="drow.surchargeLocked ? onLockedFieldKeydown($event) : null"
                                  (paste)="drow.surchargeLocked ? onLockedFieldPaste($event) : null"
                                  [attr.aria-disabled]="drow.surchargeLocked ? 'true' : null"
                                  [attr.tabindex]="drow.surchargeLocked ? '0' : null"
                                  [attr.aria-describedby]="drow.surchargeLocked ? 'surchargeLockReason-' + drow.payId : null"
                                  class="form-control form-control-sm custom-input col-width">
                                  @if (drow.surchargeLocked) {
                                   <span id="surchargeLockReason-{{drow.payId}}" class="visually-hidden">{{surchargeLockReasonText}}</span>
                                  }
                                  @if (!isAnyRowSurchargeLocked()) {
                                    @if (!drow.payComplete) {
                                      <button type="button" class="btn btn-primary btn-sm cash_paynow_butt"
                                        data-backdrop="static" data-keyboard="false"
                                        (click)="onPayClick(drow.payAmount, drow.payId, cashPayment, checkPayment)"
                                      [disabled]="disablePayNowButton(drow)">Pay Now</button>
                                    }
                                    @if (drow.payComplete) {
                                      <div class="bg-success text-white btn btn-sm cash_paynow_butt"
                                        style="width: 80px;">
                                        <i class="fa fa-check"></i>
                                      </div>
                                    }
                                  }
                                </div>
                              </td>
                              @if (isAnyRowSurchargeLocked()) {
                                <td style="width: 110px;" class="align-middle">
                                  @if (drow.surchargeFeeAmount) {
                                    <span>{{drow.surchargeFeeAmount | currency}} ({{drow.surchargeFeePercentage}}%)</span>
                                  } @else {
                                    <span>—</span>
                                  }
                                </td>
                                <td style="width: 110px;" class="align-middle">
                                  <div class="d-flex justify-content-between align-items-center">
                                    <span>{{getRowPayableAmount(drow) | currency}}</span>
                                    @if (!drow.payComplete) {
                                      <button type="button" class="btn btn-primary btn-sm cash_paynow_butt"
                                        data-backdrop="static" data-keyboard="false"
                                        (click)="onPayClick(getRowPayableAmount(drow), drow.payId, cashPayment, checkPayment)"
                                      [disabled]="disablePayNowButton(drow)">Pay Now</button>
                                    }
                                    @if (drow.payComplete) {
                                      <div class="bg-success text-white btn btn-sm cash_paynow_butt"
                                        style="width: 80px;">
                                        <i class="fa fa-check"></i>
                                      </div>
                                    }
                                  </div>
                                </td>
                              }
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end payment_tot_amt">
                <p>Remaining Amount: {{remainingAmount| currency}}</p>
              </div>
              @if (isAnyRowSurchargeLocked()) {
                <div class="d-flex justify-content-end">
                  <table class="surcharge-summary-table text-end" style="min-width:260px;">
                    <tr>
                      <td class="pe-3">Amount to be applied to the account(s):</td>
                      <td>{{originalTotalAmount | currency}}</td>
                    </tr>
                    <tr>
                      <td class="pe-3">Processing Fee</td>
                      <td>{{getTotalSurchargeFee() | currency}}</td>
                    </tr>
                    @if (getCashRoundingAmount() !== 0) {
                      <tr>
                        <td class="pe-3">Cash Rounding</td>
                        <td>{{getCashRoundingAmount() | currency}}</td>
                      </tr>
                    }
                    @if (charityContributionAmount > 0) {
                      <tr>
                        <td class="pe-3">Charity Contribution</td>
                        <td>{{charityContributionAmount | currency}}</td>
                      </tr>
                    }
                    <tr class="fw-bold">
                      <td class="pe-3">Total Amount</td>
                      <td>{{totalAmount | currency}}</td>
                    </tr>
                  </table>
                </div>
              }
              @if (paymentProcessing) {
                <div class="d-flex justify-content-end">
                  <span class="badge badge-pill badge-info">Payment is Under Process</span>
                </div>
              }
              @if (userSessionService.defaultPhoneSystem && userSessionService.defaultPhoneSystem.CallRecordingIntegrationId == 513 && userSessionService.defaultPhoneSystem.PhoneSystemId == 465) {
                <div class="d-flex justify-content-center align-items-center"
                  >
                  <button type="button" class="btn btn-primary me-3" (click)="recordAction(3)"
                  [disabled]="disablePause">Pause</button>
                  <button type="button" class="btn btn-primary" (click)="recordAction(2)"
                  [disabled]="disableResume">Resume</button>
                </div>
              }
            </div>
          </div>
          <div class="payment_bottom_button">
            @if (showAutoPay()) {
              <button type="button" class="btn btn-primary" (click)="clickautopay()"
              [disabled]="paymentStarted">Autopay / Card on File</button>
            }
            @if (auto) {
              <app-autoPay [credentials]='credentials' [achSettingPaymentGateway]='achSettingPaymentGateway'
                [facilityCreditCards]='facilityCreditCards' [Currentstore]="facilityId"
                [defaultCountryId]="defaultCountryId" [paymentGateWay]="paymentGateway"
                [dayEndSetting]="dayendSettingDetails" [AutopayProfileUpdate]="autopayProfile"
                [paymentOrigin]="processPayment.Type" (emitAutopayData)="autopayDataOnSave($event)"
                [stripePublishableKey]="stripePublishableKey" [StripeUnifiedAccountId]="StripeUnifiedAccountId"
                [enableAddressAutofill]="enableAddressAutofill" [currentLeaseNo]="processPayment.LeaseNo"
                [quickProspectTenantInfo]="quickProspectTenantInfo"
                [tenantInfo]="customerInfoPresent ? customerInfo : null" [tenantModel]="this.tenantModel? this.tenantModel : null"
              [isAutoPayRequired]="autoPayRequired" (cancelAutopay)="onAutopayCancel($event)" [resetPostPayment]="returnPostPayment" (autopayCompleted)="postAutoPay($event)"></app-autoPay>
            }
            <div class="pay_rgt_butt d-flex justify-content-between">
              @if (!showPrintEmailRcpt) {
                <button type="button" class="btn btn-outline-primary me-3"
                (click)="onClickCancelButton()" [disabled]="disableCancelButton()">Cancel</button>
              }
              <button type="button" class="btn btn-primary" (click)="goToComplete(1)"
              [disabled]="disableNextButton()">Next</button>
            </div>
          </div>
        </div>
      }

      @if (showPayFieldsEmbeddedForm) {
        <div class="third_party_payment payfields-embedded-shell">
          <div #payFieldsDialog class="payfields-embedded-content" role="dialog" aria-modal="true" aria-labelledby="payFieldsPaymentModalTitle" tabindex="-1">
            <!-- Modal header -->
            <div class="payfields-embedded-header">
              <h5 id="payFieldsPaymentModalTitle">PayFields Payment</h5>
              <button type="button" class="payfields-close-btn" (click)="onhstPayBtn('Cancel')" [disabled]="paymentStarted" aria-label="Close">&times;</button>
            </div>
            <!-- Scrollable body: order info + card fields + customer fields -->
            <div class="payfields-embedded-body">
              <h4 class="payfields-embedded-title">Order Information</h4>
              <div class="payfields-embedded-row">
                <label>Total Amount ({{getPayFieldCurrencySymbol()}}):</label>
                <span>{{payFieldsPendingAmount | number: '1.2-2'}}</span>
              </div>
              <div class="payfields-embedded-row">
                <label>Transaction Type:</label>
                <span>CREDITSALE</span>
              </div>

              <h4 class="payfields-embedded-title">Card Information</h4>
              <div class="payfields-embedded-field-row">
                <label>Card Number:<span class="required">*</span></label>
                <div id="payfields-card-number" class="payfields-secure-field"></div>
              </div>
              <div class="payfields-embedded-field-row payfields-expiry-cvv">
                <div>
                  <label>Expiry Date:<span class="required">*</span></label>
                  <div id="payfields-card-expiration" class="payfields-secure-field"></div>
                </div>
                <div>
                  <label>CVV:<span class="required">*</span></label>
                  <div id="payfields-card-cvv" class="payfields-secure-field"></div>
                </div>
              </div>

              <h4 class="payfields-embedded-title">Customer Information</h4>
              <div class="payfields-embedded-grid">
                <div>
                  <label>First Name:<span class="required">*</span></label>
                  <input class="form-control" type="text" [(ngModel)]="payFieldsBillingDetails.firstName" maxlength="50" />
                </div>
                <div>
                  <label>Middle Name:</label>
                  <input class="form-control" type="text" [(ngModel)]="payFieldsBillingDetails.middleName" maxlength="50" />
                </div>
                <div>
                  <label>Last Name:<span class="required">*</span></label>
                  <input class="form-control" type="text" [(ngModel)]="payFieldsBillingDetails.lastName" maxlength="50" />
                </div>
                <div>
                  <label>Company Name:</label>
                  <input class="form-control" type="text" [(ngModel)]="payFieldsBillingDetails.companyName" maxlength="100" />
                </div>
                <div>
                  <label>Address One:<span class="required">*</span></label>
                  <input class="form-control" type="text" [(ngModel)]="payFieldsBillingDetails.addressOne" maxlength="100" />
                </div>
                <div>
                  <label>Address Two:</label>
                  <input class="form-control" type="text" [(ngModel)]="payFieldsBillingDetails.addressTwo" maxlength="100" />
                </div>
                <div>
                  <label>City:<span class="required">*</span></label>
                  <input class="form-control" type="text" [(ngModel)]="payFieldsBillingDetails.city" maxlength="50" />
                </div>
                <div>
                  <label>Country:<span class="required">*</span></label>
                  <select class="form-select" [(ngModel)]="payFieldsBillingDetails.countryId" (change)="onPayFieldsCountryChange($event.target.value)">
                    @for (ct of countryList; track ct) {
                      <option [value]="ct.Id">{{ct.Name}}</option>
                    }
                  </select>
                </div>
                <div>
                  <label>State or Province:<span class="required" *ngIf="payFieldsStateRequired && !emptyStateList">*</span></label>
                  <select class="form-select" [(ngModel)]="payFieldsBillingDetails.stateId" [disabled]="emptyStateList">
                    <option value="0">--</option>
                    @for (st of stateList; track st) {
                      <option [value]="st.Id">{{st.Name}}</option>
                    }
                  </select>
                </div>
                <div>
                  <label>Postal Code:<span class="required">*</span></label>
                  <input class="form-control" type="text" [(ngModel)]="payFieldsBillingDetails.postalCode" maxlength="15" />
                </div>
              </div>
            </div>
            <!-- Sticky footer: Make Payment, Cancel, Auto Populate — never scroll away -->
            <div class="payfields-embedded-sticky-footer">
              <div class="payfields-embedded-actions">
                @if (customerInfoPresent) {
                  <label class="pure-material-checkbox mb-0 me-auto">
                    <input type="checkbox" class="checkBoxClass" [(ngModel)]="isAutoPopulateBillingInfo" (change)="onPayFieldsAutoPopulateChange()">
                      <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
                    </label>
                }
                <button type="button" class="btn btn-outline-primary" (click)="onhstPayBtn('Cancel')" [disabled]="paymentStarted">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="submitPayFieldsEmbeddedPayment()" [disabled]="isPayFieldsEmbeddedPaymentDisabled()">Make Payment</button>
              </div>
            </div>

            <div id="payfields-submit-host" class="payfields-submit-host"></div>
          </div>
        </div>
      }

      <!--Host Pay starts-->
      @if (showIFrame) {
        <div class="third_party_payment">
          <!--iFrame-->
          <iframe width="100%" #CPNIFrame id="CPNIFrame" height="90%" frameBorder="0" [src]="urlSafe"
          (load)="getHiddenInput()"></iframe>
          <div [ngClass]="customerInfoPresent ? 'row my-3 me-5 ms-5 autopay-footer' : 'row my-3 justify-content-end mx-0'">
            @if (customerInfoPresent) {
              <label class="pure-material-checkbox float-start">
                <input type="checkbox" class="checkBoxClass" [(ngModel)]="isAutoPopulateBillingInfo"
                  (change)="onClickAutoPopulateBillingInfo(209)">
                  <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
                </label>
              }
              <div class="pay_rgt_butt">
                <button type="button" class="btn btn-outline-primary"
                (click)="onhstPayBtn(hstPayBtnMsg)">{{hstPayBtnMsg}}</button>
              </div>
            </div>
          </div>
        }

        @if (showAchIFrame) {
          <div class="third_party_payment">
            <iframe width="100%" height="90%" frameBorder="0" #ACHIFrame id="ACHIFrame" [src]="achUrlSafe"
            (load)="getACHHiddenInput()"></iframe>
            <div class="pay_rgt_butt">
              <button type="button" class="btn btn-outline-primary"
              (click)="onhstPayBtn(hstPayBtnMsg)">{{hstPayBtnMsg}}</button>
            </div>
          </div>
        }

        <!--Host Pay ends-->

        <!--Host Pay starts-->
        <ng-template #showTDHostedForm>
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Hosted Page Payment</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelTDForm()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <form id="checkout-form" class="text-center">
              <div>
                <div class="form-group col-xs-6 has-feedback" id="card-number-bootstrap">
                  <div id="card-number" class="form-control"></div>
                  <label class="help-block" for="card-number" id="card-number-error"></label>
                </div>
                <div class="form-group col-xs-6"></div>
              </div>
              <div>
                <div class="form-group col-xs-2 has-feedback" id="card-cvv-bootstrap">
                  <div id="card-cvv" class="form-control"></div>
                  <label class="help-block" for="card-cvv" id="card-cvv-error"></label>
                </div>
                <div class="form-group col-xs-10"></div>
              </div>
              <div>
                <div class="form-group col-xs-2 has-feedback" id="card-expiry-bootstrap">
                  <div id="card-expiry" class="form-control"></div>
                  <label class="help-block" for="card-expiry" id="card-expiry-error"></label>
                </div>
                <div class="form-group col-xs-10"></div>
              </div>
              <div class="col-xs-2 text-center">
                <button #payButton id="pay-button" type="submit" class="btn btn-primary disabled" disabled="true"
                hidden="true">Pay</button>
              </div>
            </form>
            <div class="col-xs-2 text-center">
              <button #BtnPay id="BtnPay" class="btn btn-primary disabled" hidden="true"
              (click)="callSaveTDPayment()">Pay</button>
              <button #BtnError id="BtnError" class="btn btn-primary disabled" hidden="true"
              (click)="callOnTokenError()">Pay</button>
              <input #txtTransactionId id="txtTransactionId" hidden="true" type="text" />
              <input #isTDFormValid id="isTDFormValid" hidden="true" type="text" />
              <input #customCardDetails id="customCardDetails" hidden="true" type="text" />
              <div id="feedback"></div>
            </div>
            <div class="row mx-0">
              <input type="text" class="form-control" placeholder="Name On Card" [(ngModel)]="tdNameOnCard" required
                maxlength="30" #noc="ngModel" />
                @if (noc.errors && noc.touched) {
                  <div>
                    @if (noc.errors.required) {
                      <div>Name on Card is required.</div>
                    }
                  </div>
                }
              </div>
              @if (fieldsRequired) {
                <div>
                  <div class="row mx-0 mt-3">
                    <h6>Billing Information:</h6>
                  </div>
                  <div class="row mt-3">
                    @if (isMandatory('tdFName')) {
                      <div class="form-group col-md-6">
                        <label>First Name<span class="required">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="tdFName" maxlength="15" required #fnm="ngModel"
                          (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                          @if (fnm.errors && fnm.touched) {
                            <div>
                              @if (fnm.errors.required) {
                                <div>First Name is required.</div>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (isMandatory('tdLName')) {
                        <div class="form-group col-md-6">
                          <label>Last Name<span class="required">*</span></label>
                          <input type="text" class="form-control" [(ngModel)]="tdLName" maxlength="15" required #lnm="ngModel"
                            (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                            @if (lnm.errors && lnm.touched) {
                              <div>
                                @if (lnm.errors.required) {
                                  <div>Last Name is required.</div>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div class="row mt-3">
                        @if (isMandatory('tdAddress')) {
                          <div class="form-group col-md-6">
                            <label>Address<span class="required">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]="tdAddress" maxlength="50" required
                              #add="ngModel" (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                              @if (add.errors && add.touched) {
                                <div>
                                  @if (add.errors.required) {
                                    <div>Address is required.</div>
                                  }
                                </div>
                              }
                            </div>
                          }
                          @if (isMandatory('tdCity')) {
                            <div class="form-group col-md-6">
                              <label>City<span class="required">*</span></label>
                              <input type="text" class="form-control" [(ngModel)]="tdCity" maxlength="15" required #noc="ngModel"
                                (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                @if (noc.errors && noc.touched) {
                                  <div>
                                    @if (noc.errors.required) {
                                      <div>City is required.</div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </div>
                          <div class="row mt-3">
                            @if (isMandatory('tdCountry')) {
                              <div class="form-group col-md-6">
                                <label>Country<span class="required">*</span></label>
                                <select id="inputcountry" class="form-select" [(ngModel)]="tdCountry"
                                  (change)="onCountryChange($event.target.value, 1)">
                                  @for (ct of countryList; track ct) {
                                    <option [value]="ct.Id">{{ct.Name}}</option>
                                  }
                                </select>
                              </div>
                            }
                            @if (isMandatory('tdState')) {
                              <div class="form-group col-md-6">
                                <label>State@if (!emptyStateList) {
                                  <span class="required">*</span>
                                }</label>
                                <select id="inputcountry" class="form-select" [(ngModel)]="tdState" [disabled]="emptyStateList">
                                  @if (emptyStateList || tdState == 0) {
                                    <option value="0">--</option>
                                  }
                                  @for (st of stateList; track st) {
                                    <option [value]="st.Id">{{st.Name}}</option>
                                  }
                                </select>
                              </div>
                            }
                          </div>
                          <div class="row mt-3">
                            @if (isMandatory('tdZip')) {
                              <div class="form-group col-md-6">
                                <label>Zip Code<span class="required">*</span></label>
                                <input type="text" class="form-control" [(ngModel)]="tdZip" maxlength="15" required #zpc="ngModel"
                                  (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars>
                                  @if (zpc.errors && zpc.touched) {
                                    <div>
                                      @if (zpc.errors.required) {
                                        <div>Zip Code is required.</div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                              @if (isMandatory('tdCellphone')) {
                                <div class="form-group col-md-6">
                                  <label>Cell Phone<span class="required">*</span></label>
                                  <ejs-maskedtextbox #cellphone [mask]="PhoneNumberMask" name="phone" id="inputCellPhone"
                                    [(ngModel)]="tdCellphone" required #cpn="ngModel" (change)="cellPhoneValidator($event)">
                                  </ejs-maskedtextbox>
                                  @if ((cpn.touched || cpn.dirty)) {
                                    <div>
                                      @if (cpn.errors && cpn.errors.required) {
                                        <div>Cell Phone is required.</div>
                                      }
                                      @if (cellphoneNotValid) {
                                        <div>Enter 10 digit Phone Number.</div>
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                            <div class="row mt-3">
                              @if (isMandatory('tdEmail')) {
                                <div class="form-group col-md-6">
                                  <label>Email<span class="required">*</span></label>
                                  <input type="text" class="form-control" [(ngModel)]="tdEmail" maxlength="250"
                                    [pattern]="emailIdsPattern" required #tdemail="ngModel"
                                    (keypress)="restrictAddressinput($event)" appRestrictHtmltagchars
                                    (ngModelChange)="onEmailEntered(tdemail)">
                                    @if (tdemail.errors && (tdemail.touched || tdemail.dirty)) {
                                      <div>
                                        @if (tdemail.errors.pattern) {
                                          <div>Email Id is not valid.</div>
                                        }
                                        @if (tdemail.errors.required) {
                                          <div>Email is required.</div>
                                        }
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </div>
                        <div [ngClass]="fieldsRequired && customerInfoPresent ? 'modal-footer autopay-footer' : 'modal-footer'">
                          @if (fieldsRequired && customerInfoPresent) {
                            <label class="pure-material-checkbox float-start">
                              <input type="checkbox" class="checkBoxClass" [(ngModel)]="isAutoPopulateBillingInfo"
                                (change)="onClickAutoPopulateBillingInfo(208)">
                                <span class="charitypay_text mt-0">Auto Populate Customer Information</span>
                              </label>
                            }
                            <div class="pay_rgt_butt">
                              <button type="button" class="btn btn-outline-primary me-3" (click)="cancelTDForm()">Cancel</button>
                              <button type="button" (click)="onTDHostedPagePay()" class="btn btn-primary"
                              [disabled]="disableTDForm() || !isTDEmailValid">Make Payment</button>
                            </div>
                          </div>
                        </ng-template>

                        <!-- cash payment popup -->
                        <ng-template #cashPayment>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Cash Payment</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onPayCancel()">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body common_form">
                            <div class="col-12 px-0">
                              <div class="row">
                                <label class="col-md-4">Amount@if (amountField) {
                                  <span class="required">*</span>
                                }</label>
                                <div class="col-md-8">
                                  <input type="text" class="form-control" [value]="amountToPay | currency" readonly />
                                </div>
                              </div>
                              @if (paymentSetting?.DisplayChangeAmount) {
                                <div class="row mt-3">
                                  <label class="col-md-4">Tender Amount@if (tenderAmtField) {
                                    <span class="required">*</span>
                                  }</label>
                                  <div class="col-md-8">
                                    <input type="text" class="form-control" (keypress)="numberOnly($event)"
                                      (ngModelChange)="tenderChanged($event)" [ngModel]="tenderAmount "
                                      [appTwoDigitDecimal]='costValueDirectiveSetting' />
                                      @if ((tenderAmount==null) && tenderAmtField) {
                                        <div class="alert alert-danger">
                                          <span>Tender Amount is required</span>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                                @if (paymentSetting?.DisplayChangeAmount) {
                                  <div class="row mt-3">
                                    <label class="col-md-4">Change Amount@if (changeAmtField) {
                                      <span class="required">*</span>
                                    }</label>
                                    <div class="col-md-8">
                                      <input type="text" class="form-control" [value]="changeAmount | currency" readonly />
                                      @if (changeAmtField && cField.touched) {
                                        <div class="alert alert-danger">
                                          <span>Change Amount is required</span>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-outline-primary me-3" (click)="onPayCancel()">Cancel</button>
                              <div class="button_tooltip">
                                <button type="button" (click)="gotoPaymentSuccess(paymentSuccess,amountToPay)" class="btn btn-primary"
                                  [disabled]="tenderAmount < amountToPay || tenderAmount==null || requireFullPaymentForTransaction">Pay
                                {{amountToPay | currency}}</button>
                                @if ((requireFullPaymentForTransaction)) {
                                  <div class="button_tooltip_modal">
                                    <p class="mb-0">Tender Amount cannot be lesser than Amount payable</p>
                                  </div>
                                }
                              </div>
                            </div>
                          </ng-template>

                          <!-- payment success popup -->
                          <ng-template #paymentSuccess>
                            <div class="modal-body">
                              <div class="row mx-0">
                                @if (paymentSuccessFul) {
                                  <div class="payment_successful_txt">
                                    <app-success-tick></app-success-tick><span>{{prePayStatus}} {{payStatus}}!</span>
                                  </div>
                                }
                                @if (!paymentSuccessFul) {
                                  <div class="payment_failed_txt">
                                    <app-failure-cross></app-failure-cross><span>{{prePayStatus}} {{payStatus}}!</span>
                                  </div>
                                }
                              </div>
                              @if (paymentSuccessFul && showPrintEmailRcpt) {
                                <div class="row mx-0 justify-content-between">
                                  @if (isResponse) {
                                    <div class="confirmation_det" style="width: 100%;">
                                      <ul>
                                        @if (apiResponse.ReceiptId && apiResponse.ReceiptId !== 0) {
                                          <li>
                                            <label class="fw-bold">Receipt#</label>
                                            @if (apiResponse.ReceiptId) {
                                              <div><span>{{apiResponse.ReceiptId}}</span></div>
                                            } @else {
                                              <span>{{apiResponse.Id}}</span>
                                            }
                                          </li>
                                        }
                                        <li>
                                          <label class="fw-bold">Amount</label>
                                          <span>{{tillNowPaid | currency}}</span>
                                        </li>
                                        <li>
                                          <label class="fw-bold">Date</label>
                                          <span>{{apiResponse.date | date: 'MM/dd/yyyy hh:mm:ss a'}}</span>
                                        </li>
                                      </ul>
                                    </div>
                                  }
                                </div>
                              }
                              @if (!paymentSuccessFul) {
                                <div class="row mt-4 pt-2 mx-0 text-center"><label class="w-100"><strong>Uh-oh! We
                                Were Unable To Process Your Payment</strong></label></div>
                              }
                              @if (!paymentSuccessFul) {
                                <div class="text-center">
                                  <div class="payment_fail_reason">
                                    <ul>
                                      <li>
                                        <label class="fw-bold">{{paymentFailReason}}</label>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              }
                            </div>
                            @if (prePayStatus !== 'Payment' || !paymentSuccessFul) {
                              <div class="modal-footer">
                                <button type="button" class = "btn btn-primary" [disabled]="" (click)="afterpaymentSuccess()">OK</button>
                                @if (isStripeTerminalPay) {
                                  <button type="button" class=" btn btn-primary" style="position: absolute;left: 15px;" (click)="cancelTerminalAction()">Reset Device</button>
                                }
                              </div>
                            }
                          </ng-template>

                          <!-- Check Payment modal start -->
                          <ng-template #checkPayment>
                            <div class="modal-header">
                              <h5 class="modal-title">Check Payment</h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCheckCancel()">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body common_form">
                              <div class="row">
                                <div class="col-md-3"><label>Amount@if (amountFieldforcheck) {
                                  <span class="required">*</span>
                                }</label></div>
                                <div class="col-md-9"><input type="text" [value]="amountToPay | currency" class="form-control" readonly />
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-3"><label>Check #@if (checknumber) {
                                  <span class="required">*</span>
                                }</label></div>
                                <div class="col-md-9"><input type="text" [(ngModel)]="checkNo" class="form-control" maxlength="15"
                                  #checkfield1="ngModel" (paste)="onPaste($event)" />
                                  @if (checknumber && (checkNo == null || checkNo == '') &&  checkfield1.touched ) {
                                    <div class="alert alert-danger"
                                      >
                                      <span>Check Number is required</span>
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-3"><label>Check Date@if (checkdatefield) {
                                  <span class="required">*</span>
                                }</label></div>
                                <div class="col-md-9">
                                  <ejs-datepicker Class="form-control p-0 h-auto" [(ngModel)]="checkDate" #checkdatefield2="ngModel"
                                    [max]="today" floatLabelType='Always' format='MM/dd/yyyy' required>
                                  </ejs-datepicker>
                                  @if (checkdatefield  && checkDate == null) {
                                    <div class="alert alert-danger">
                                      <span>Check Date is required</span>
                                    </div>
                                  }
                                </div>
                              </div>
                              <div class="row mt-3">
                                <div class="col-md-3"><label>Bank@if (checkbankname) {
                                  <span class="required">*</span>
                                }</label></div>
                                <div class="col-md-9"><input type="text" [(ngModel)]="checkBank" #checkbankname1="ngModel" maxlength="15"
                                  class="form-control" />
                                  @if (checkbankname && checkBank == '' && checkbankname1.touched ) {
                                    <div class="alert alert-danger">
                                      <span>Bank Name is required</span>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal"
                              (click)="onCheckCancel()">Cancel</button>
                              <button type="button" data-dismiss="modal" class="btn btn-primary" [disabled]="onDisableCheck()"
                              (click)="gotoPaymentSuccess(paymentSuccess,amountToPay)">Pay {{amountToPay| currency}}</button>
                            </div>
                          </ng-template>
                          <!-- Check Payment modal end -->

                          <div bsModal #printReceiptPopup="bs-modal"[config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
                            aria-labelledby="dialog-sizes-name1">
                            <div class="modal-dialog modal-dialog-centered modal-fullSize  modal-lg modal-xxl">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <h5 class="modal-title">Preview</h5>
                                  <button type="button" class="close" (click)="redirectToMaster()" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div class="modal-body">
                                  <div>
                                    <div class="row mx-0 align-items-center justify-content-center" id="recieptContainerPayment"
                                      style="min-height: 500px">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Manual Authorization modal start -->
                          <form #manualAuthForm="ngForm">
                            <ng-template #manualAuthorization>
                              <div class="modal-header">
                                <h5 class="modal-title">Manual Authorization</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="OnmanualCancel()">
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body common_form Manual_auth_form">
                                <div class="manual_form_row">
                                  <div class="manual_card">
                                    <label>Card # (Last 4 Digits)@if (isRequired('mManualCardNumber')) {
                                      <span class="required"
                                      >*</span>
                                    }</label>
                                    <div class="inputbox">
                                      <input type="text" class="form-control" [(ngModel)]="ManualCardNumber" minlength="4"
                                        maxlength="4" name="mManualCardNumber" #mManualCardNumber="ngModel"
                                        (keypress)="numberOnly($event)">
                                        @if (manualAuthForm.form.get('mManualCardNumber').errors  &&
                                          (manualAuthForm.form.get('mManualCardNumber').dirty || manualAuthForm.form.get('mManualCardNumber').touched) &&
                                          manualAuthForm.form.get('mManualCardNumber').validator !== null) {
                                          <div class="alert alert-danger">
                                            @if (manualAuthForm.form.get('mManualCardNumber').errors.required) {
                                              <span>Manual Card
                                              Number is required</span>
                                            }
                                          </div>
                                        }
                                        @if (ManualCardNumber && ManualCardNumber.length > 0 && ManualCardNumber.length < 4) {
                                          <div class="alert alert-danger"
                                            >
                                            <span>Credit Card number must be 4 characters long</span>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    <div class="manual_card_exp">
                                      <label>Exp @if (isRequired('mManualCardExp')) {
                                        <span class="required">*</span>
                                      }</label>
                                      <div class="inputbox">
                                        <ejs-maskedtextbox [mask]="ExpNumberMask" type="text" [(ngModel)]="ManualCardExp"
                                          name="mManualCardExp" #mManualCardExp="ngModel" (keyup)="OnChangeManualCardExp($event)">
                                        </ejs-maskedtextbox>
                                        @if (ManualCardExpIsDirty && (!ValidManualCardExp) && ManualCardExp.length != 0) {
                                          <div class="alert alert-danger"
                                            >
                                            Invalid Card Expiry Date
                                          </div>
                                        }
                                        @if (ManualCardExpIsDirty && ManualCardExp.length == 0) {
                                          <div class="alert alert-danger">
                                            Manual Card Exp is Required
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                  <div class="manual_form_row mt-3">
                                    <label>Name on the Card @if (isRequired('mManualCardName')) {
                                      <span class="required">*</span>
                                    }</label>
                                    <div class="inputbox">
                                      <input type="text" class="form-control" [(ngModel)]="ManualCardName" name="mManualCardName"
                                        maxlength="30" #mManualCardName="ngModel">
                                        @if (manualAuthForm.form.get('mManualCardName').errors  &&
                                          (manualAuthForm.form.get('mManualCardName').dirty || manualAuthForm.form.get('mManualCardName').touched) &&
                                          manualAuthForm.form.get('mManualCardName').validator !== null) {
                                          <div class="alert alert-danger">
                                            @if (manualAuthForm.form.get('mManualCardName').errors.required) {
                                              <span>
                                              Card Name is required</span>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    <div class="manual_form_row mt-3">
                                      <label> Card Type @if (isRequired('mCardType')) {
                                        <span class="required">*</span>
                                      }</label>
                                      <div class="inputbox">
                                        <select class="form-select" name="mCardType" [(ngModel)]="ManualCardType" #mCardType="ngModel"
                                          (change)="onChangeManualCard($event)" (keyup)="onChangeManualCard($event)">
                                          <option value="0" selected hidden>Select</option>
                                          @for (item of creditCardList; track item) {
                                            <option [value]="item.Id">{{item.Name}}</option>
                                          }
                                        </select>
                                        @if (isManualSelectCard) {
                                          <div class="alert alert-danger">
                                            Card Type is required
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    <div class="manual_form_row mt-3">
                                      <label>Authorization # @if (isRequired('mManualCardAuthorization')) {
                                        <span class="required"
                                        >*</span>
                                      }</label>
                                      <div class="inputbox">
                                        <input type="tel" class="form-control" [(ngModel)]="ManualCardAuthorization" maxlength="16"
                                          name="mManualCardAuthorization" #mManualCardAuthorization="ngModel"
                                          (keypress)="IsAlphaNumeric($event)">
                                          @if (manualAuthForm.form.get('mManualCardAuthorization').errors  &&
                                            (manualAuthForm.form.get('mManualCardAuthorization').dirty || manualAuthForm.form.get('mManualCardAuthorization').touched) &&
                                            manualAuthForm.form.get('mManualCardAuthorization').validator !== null) {
                                            <div class="w-100">
                                              @if (manualAuthForm.form.get('mManualCardAuthorization').errors.required) {
                                                <span class="alert alert-danger float-start"
                                                  >
                                                Authorization is required</span>
                                              }
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    <div class="modal-footer">
                                      <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal"
                                      (click)="OnmanualCancel()">Cancel</button>
                                      <button type="button" data-dismiss="modal" class="btn btn-primary"
                                        [disabled]='manualAuthForm.invalid || ManualCardAuthorization.length == 0 || !ValidManualCardExp || isManualSelectCard || ManualCardType.length == 0 || ManualCardType == "" || (ManualCardNumber && ManualCardNumber.length > 0 && ManualCardNumber.length < 4)'
                                      (click)="gotoPaymentSuccess(paymentSuccess,amountToPay)">OK</button>
                                    </div>
                                  </ng-template>
                                </form>
                                <!-- Manual Authorization modal end-->

                                <ng-template #selectDevicePopup>
                                  <div class="modal-header">
                                    <h5 class="modal-title">Select Device</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="OnCardcancel()">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <div class="confirmation_det bg-white mx-auto w-100">
                                      <label>Please select a Device</label>
                                      <select class="form-select" [(ngModel)]="selectedDeviceId">
                                        <option value="0" disabled>Select</option>
                                        @for (device of terminalDevicesList; track device) {
                                          <option [value]="device.Id">{{device.DeviceId}}</option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal"
                                    (click)="OnCardcancel()">Cancel</button>
                                    <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="onSelectDevice()"
                                    [disabled]="selectedDeviceId == '0'">Select</button>
                                  </div>
                                </ng-template>

                                <ng-template #selectStripeDevicePopup>
                                  <div class="modal-header">
                                    <h5 class="modal-title">Select Device</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="OnCardcancel()">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <div class="confirmation_det bg-white mx-auto w-100">
                                      <label>Please select a Reader</label>
                                      <select class="form-select" [(ngModel)]="selectStripeReaderId">
                                        <option value="" disabled>Select</option>
                                        @for (device of terminalDevicesList; track device) {
                                          <option [value]="device.TerminalReaderId">{{device.Name}}
                                          </option>
                                        }
                                      </select>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal"
                                    (click)="OnCardcancel()">Cancel</button>
                                    <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="onSelectDevice()"
                                    [disabled]="selectStripeReaderId == ''">Select</button>
                                  </div>
                                </ng-template>

                                <ng-template #showTDchallengeForm>
                                  <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel">Payment Authentication</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onTransactionCancel()">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div class="modal-body">
                                    <iframe class="custom-frame" id="three-d-frame" width="600" height="450" frameborder="0"
                                    name="threedframe"></iframe>
                                  </div>
                                  <div class="modal-footer">
                                  </div>
                                </ng-template>

                                <ng-template #cancelPaymentModal>
                                  <div class="modal-header">
                                    <h5 class="modal-title">Confirm</h5>
                                  </div>
                                  <div class="modal-body ptb24">
                                    <p class="mb-0">
                                      Are you sure to Cancel the Transaction? Cancelling will Void any Payment that has been
                                      Approved by Payment Gateway as part of this Transaction
                                    </p>
                                  </div>
                                  <div class="modal-footer">
                                    <button class="btn btn-outline-primary" type="button" (click)="onCancelPaymentNo()">No</button>
                                    <button class="btn btn-primary" type="button" (click)="onCancelPaymentYes()">Yes</button>
                                  </div>
                                </ng-template>

                                <!-- ACH Manual Authorization modal start -->
                                <form #achManualAuthForm="ngForm">
                                  <ng-template #achManualAuthorization>
                                    <div class="modal-header">
                                      <h5 class="modal-title"> ACH Manual Authorization</h5>
                                      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onACHManualCancel()">
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                    <div class="modal-body common_form Manual_auth_form">
                                      <div class="manual_form_row">
                                        <div class="manual_form_row mt-3">
                                          <label>Routing Number@if (routingNumberfield) {
                                            <span class="required">*</span>
                                          }</label>
                                          <div class="inputbox">
                                            <input type="text" class="form-control" [(ngModel)]="routingNumber" minlength="4" maxlength="9"
                                              name="achroutingNumber" #achroutingNumber="ngModel" (keypress)="numberOnly($event)" [required]="routingNumberfield">
                                              @if (achroutingNumber.invalid && (achroutingNumber.touched || achroutingNumber.dirty)) {
                                                <div class="alert alert-danger"
                                                  >
                                                  @if (achroutingNumber.errors.required) {
                                                    <span>ACH Manual Routing Number is required</span>
                                                  }
                                                  @if (achroutingNumber.errors.minlength) {
                                                    <span>Routing Number must be at
                                                    least 4 characters long</span>
                                                  }
                                                </div>
                                              }
                                            </div>
                                          </div>

                                          <div class="manual_form_row mt-3">
                                            <label>Account Number @if (accountNumberfield) {
                                              <span class="required">*</span>
                                            }</label>
                                            <div class="inputbox">
                                              <input type="text" class="form-control" [(ngModel)]="accountNumber" name="achaccountNumber"
                                                minlength="4" maxlength="17" #achAccountNumber="ngModel" (keypress)="numberOnly($event)" [required]="accountNumberfield">
                                                @if (achAccountNumber.errors  && (achAccountNumber.touched|| achAccountNumber.dirty)) {
                                                  <div class="alert alert-danger"
                                                    >
                                                    @if (achAccountNumber.errors.required) {
                                                      <span>ACH Manual Account Number is required</span>
                                                    }
                                                    @if (achAccountNumber.errors.minlength) {
                                                      <span>Account Number must be at
                                                      least 4 characters long</span>
                                                    }
                                                  </div>
                                                }
                                              </div>
                                            </div>

                                            <div class="manual_form_row mt-3">
                                              <label>Check Number @if (checkNumberfield) {
                                                <span class="required">*</span>
                                              }</label>
                                              <div class="inputbox">
                                                <input type="text" class="form-control" [(ngModel)]="checkNumber" name="achcheckNumber"
                                                  maxlength="15" #achCheckNumber="ngModel" (keypress)="numberOnly($event)" [required]="checkNumberfield" >
                                                  @if (achCheckNumber.errors  && (achCheckNumber.touched ||achCheckNumber.dirty)) {
                                                    <div class="alert alert-danger"
                                                      >
                                                      @if (achCheckNumber.errors.required) {
                                                        <span>ACH Manual Check Number is required</span>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                              <div class="manual_form_row mt-3">
                                                <label>Account Type @if (accountTypefield) {
                                                  <span class="required">*</span>
                                                }</label>
                                                <div class="inputbox">
                                                  <select class="form-select" [(ngModel)]="accountType" name="achaccountType"
                                                    #achAccountType="ngModel" (change)="onChangeAccounType($event)" [required]="accountTypefield" >
                                                    <option [value]="279">Checking</option>
                                                    <option [value]="278">Savings</option>
                                                  </select>
                                                  @if (achAccountType.errors && (achAccountType.touched ||achAccountType.dirty)) {
                                                    <div class="alert alert-danger"
                                                      >
                                                      @if (achAccountType.errors.required) {
                                                        <span>Account Type is required</span>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              </div>
                                              <div class="manual_form_row mt-3">
                                                <label>Name on Account@if (nameonAccountfield) {
                                                  <span class="required">*</span>
                                                }</label>
                                                <div class="inputbox">
                                                  <input type="text" class="form-control" [(ngModel)]="nameonAccount" name="achnameonAccount"
                                                    maxlength="30" #achNameOnAccount="ngModel" [required]="nameonAccountfield">
                                                    @if (achNameOnAccount.invalid && (achNameOnAccount.touched || achNameOnAccount.dirty)) {
                                                      <div class="alert alert-danger"
                                                        >
                                                        @if (achNameOnAccount.errors.required) {
                                                          <span>
                                                          Name on Account is required</span>
                                                        }
                                                      </div>
                                                    }
                                                  </div>
                                                </div>
                                                <div class="manual_form_row mt-3">
                                                  <label>Authorization # @if (authorizationfield) {
                                                    <span class="required">*</span>
                                                  }</label>
                                                  <div class="inputbox">
                                                    <input type="tel" class="form-control" [(ngModel)]="achManualCardAuthorization" maxlength="16"
                                                      name="achauthorization" #achAuthorization="ngModel" (keypress)="IsAlphaNumeric($event)"
                                                      [required]="authorizationfield">
                                                      @if (achAuthorization.invalid && (achAuthorization.touched || achAuthorization.dirty)) {
                                                        <div class="alert alert-danger"
                                                          >
                                                          @if (achAuthorization.errors.required) {
                                                            <span>
                                                            Authorization is required</span>
                                                          }
                                                        </div>
                                                      }
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="modal-footer">
                                                <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal"
                                                (click)="onACHManualCancel()">Cancel</button>
                                                <button type="button" data-dismiss="modal" class="btn btn-primary"
                                                  [disabled]='achManualAuthForm.invalid || achManualCardAuthorization.length == 0'
                                                (click)="gotoPaymentSuccess(paymentSuccess,amountToPay)">OK</button>
                                              </div>
                                            </ng-template>
                                          </form>

                                          <form #eftManualAuthForm="ngForm">
                                            <ng-template #eftManualAuthorization>
                                              <div class="modal-header">
                                                <h5 class="modal-title">EFT Manual Authorization</h5>
                                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onEFTManualCancel()">
                                                  <span aria-hidden="true">&times;</span>
                                                </button>
                                              </div>
                                              <div class="modal-body common_form Manual_auth_form">

                                                <div class="manual_form_row mt-3">
                                                  <label>Bank Name<span class="required">*</span></label>
                                                  <div class="inputbox">
                                                    <input type="text" class="form-control" [(ngModel)]="bankName" name="eftBankName"
                                                      #eftBankName="ngModel" required>
                                                      @if (eftBankName.invalid && (eftBankName.dirty || eftBankName.touched)) {
                                                        <div class="alert alert-danger"
                                                          >
                                                          @if (eftBankName.errors.required) {
                                                            <span>Bank Name is required</span>
                                                          }
                                                        </div>
                                                      }
                                                    </div>
                                                  </div>

                                                  <div class="manual_form_row mt-3">
                                                    <label>Account Type <span class="required">*</span></label>
                                                    <div class="inputbox">
                                                      <select class="form-select" [(ngModel)]="accountType" name="eftAccountType"
                                                        #eftAccountType="ngModel" required>
                                                        <option [value]="279">Checking</option>
                                                        <option [value]="278">Savings</option>
                                                      </select>
                                                      @if (eftAccountType.invalid && (eftAccountType.dirty || eftAccountType.touched)) {
                                                        <div class="alert alert-danger"
                                                          >
                                                          @if (eftAccountType.errors.required) {
                                                            <span>Account Type is required</span>
                                                          }
                                                        </div>
                                                      }
                                                    </div>
                                                  </div>

                                                  <div class="manual_form_row mt-3">
                                                    <label>Account Number <span class="required">*</span></label>
                                                    <div class="inputbox">
                                                      <input type="text" class="form-control" [(ngModel)]="accountNumber" name="eftAccountNumber"
                                                        minlength="4" maxlength="17" #eftAccountNumber="ngModel" (keypress)="numberOnly($event)"
                                                        required>
                                                        @if (eftAccountNumber.invalid && (eftAccountNumber.dirty || eftAccountNumber.touched)) {
                                                          <div class="alert alert-danger"
                                                            >
                                                            @if (eftAccountNumber.errors.required) {
                                                              <span>Account Number is required</span>
                                                            }
                                                            @if (eftAccountNumber.errors.minlength) {
                                                              <span>Account Number must be at least 4 characters
                                                              long</span>
                                                            }
                                                          </div>
                                                        }
                                                      </div>
                                                    </div>

                                                    <div class="manual_form_row mt-3">
                                                      <label>Authorization # <span class="required">*</span></label>
                                                      <div class="inputbox">
                                                        <input type="tel" class="form-control" [(ngModel)]="eftManualCardAuthorization" maxlength="16"
                                                          name="eftAuthorization" #eftAuthorization="ngModel" (keypress)="IsAlphaNumeric($event)"
                                                          required>
                                                          @if (eftAuthorization.invalid && (eftAuthorization.dirty || eftAuthorization.touched)) {
                                                            <div class="alert alert-danger"
                                                              >
                                                              @if (eftAuthorization.errors.required) {
                                                                <span>Authorization # is required</span>
                                                              }
                                                            </div>
                                                          }
                                                        </div>
                                                      </div>

                                                      <div class="manual_form_row mt-3">
                                                        <label>Routing Number<span class="required">*</span></label>
                                                        <div class="inputbox">
                                                          <input type="text" class="form-control" [(ngModel)]="routingNumber" minlength="4" maxlength="9"
                                                            name="eftRoutingNumber" #eftRoutingNumber="ngModel" (keypress)="numberOnly($event)" required>
                                                            @if (eftRoutingNumber.invalid && (eftRoutingNumber.dirty || eftRoutingNumber.touched)) {
                                                              <div class="alert alert-danger"
                                                                >
                                                                @if (eftRoutingNumber.errors.required) {
                                                                  <span>Routing Number is required</span>
                                                                }
                                                                @if (eftRoutingNumber.errors.minlength) {
                                                                  <span>Routing Number must be at least 4 characters
                                                                  long</span>
                                                                }
                                                              </div>
                                                            }
                                                          </div>
                                                        </div>

                                                      </div>

                                                      <div class="modal-footer">
                                                        <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal"
                                                        (click)="onEFTManualCancel()">Cancel</button>
                                                        <button type="button" data-dismiss="modal" class="btn btn-primary"
                                                          [disabled]='eftManualAuthForm.invalid || eftManualCardAuthorization.length == 0 || bankName === "" || routingNumber === "" || accountNumber === ""'
                                                        (click)="gotoPaymentSuccess(paymentSuccess, amountToPay)">OK</button>
                                                      </div>
                                                    </ng-template>
                                                  </form>


<ng-template #showStripePage>
    <app-stripe-payment [module]="stripeModule" [PublishableKey]="stripePublishableKey"
        [isPaymentWithAutoPay] = "isPaymentWithAutoPay"
        (emitStripeModalClose)="closeStripeModal($event)" [paymentMode]="selectedPaymentMode"
        [mandatoryFieldsList]="mandatoryFieldsTD" [stripeClientSecret]="stripeClientSecret"
        [UnifiedAccountId]="StripeUnifiedAccountId" [enableAddressAutofill]="enableAddressAutofill"
        (emitConfirmaTokenResponse)="getConfirmationTokenData($event)" (GetChargesDetailsByIntentId)="GetChargesDetailsByIntentId()"
        (loaderStatus)="handleLoaderStatus($event)"
        [customerInfo]="customerInfoPresent ? customerInfo : null"  [tenantInfo]="this.tenantModel? this.tenantModel : null"></app-stripe-payment>
</ng-template>

                                                  <ng-template #remotePay>
                                                    <div class="modal-header">
                                                      <h5 class="modal-title" id="exampleModalLabel">Remote Pay</h5>
                                                      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onRemotePayCancel()">
                                                        <span aria-hidden="true">&times;</span>
                                                      </button>
                                                    </div>
                                                    <div class="modal-body common_form">
                                                      <div class="row">
                                                        <div class="col-md-6">
                                                          <label class="pure-material-checkbox">
                                                            <input type="checkbox" class="custom-control-input" [(ngModel)]="remotePayIsEmail"
                                                              [disabled]="remotePayEmailId == '' || remotePayEmailId == null" name="emailCheckBox">
                                                              <span>Email</span>
                                                            </label>
                                                            <div class="row mx-0 mt-2">
                                                              <input type="text" class="form-control" name="email" [(ngModel)]="remotePayEmailId"
                                                                [pattern]="emailIdsPattern" [ngModelOptions]="{standalone: true}" [title]="remotePayEmailId"
                                                                #emailVal="ngModel">
                                                                @if (emailVal.errors !== null && (emailVal.dirty || emailVal.touched)) {
                                                                  <div class="alert alert-danger"
                                                                    >
                                                                    @if (emailVal.errors.pattern) {
                                                                      <span> Enter valid E-Mail Id <br>
                                                                      </span>
                                                                    }
                                                                  </div>
                                                                }
                                                              </div>
                                                            </div>
                                                            <div class="col-md-6">
                                                              <label class="pure-material-checkbox checkbox-Margin">
                                                                <input type="checkbox" class="custom-control-input" [(ngModel)]="remotePayIsSMS"
                                                                  [disabled]="disableRemotePaySms(smsVal) || !remotePayIsSmsAlert" name="isSMSChecked">
                                                                  <span>SMS</span>
                                                                </label>
                                                                <div class="row mx-0 mt-2">
                                                                  <ejs-maskedtextbox [mask]="PhoneNumberMask" name="sms" id="inputCellPhone" #smsVal="ngModel"
                                                                    [(ngModel)]="remotePayPhoneNumber">
                                                                  </ejs-maskedtextbox>
                                                                  @if (smsVal.value.length < 10 && (smsVal.dirty || smsVal.touched)) {
                                                                    <div class="alert alert-danger"
                                                                      >
                                                                      <span> Enter valid Phone Number<br></span>
                                                                    </div>
                                                                  }
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div class="modal-footer">
                                                            <button type="button" class="btn btn-outline-primary me-3" (click)="onRemotePayCancel()">Cancel</button>
                                                            <button type="button" (click)="onRemotePayOK()" class="btn btn-primary"
                                                            [disabled]="disableRemotePayOK(smsVal, emailVal)">OK</button>
                                                          </div>
                                                        </ng-template>

                                                        <ng-template #SelectAutopayorCardOnFile>
                                                          <div class="modal-header">
                                                            <h5 class="modal-title">{{autopayHeader}}</h5>
                                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onSelectAutopay('cancel')">
                                                              <span aria-hidden="true">&times;</span>
                                                            </button>
                                                          </div>
                                                          <div class="modal-body">
                                                            <div class="confirmation_det bg-white mx-auto w-100">
                                                              <label>{{autopayMessage}}</label>
                                                            </div>
                                                          </div>
                                                          <div class="modal-footer justify-content-between">
                                                            <div>
                                                              <button type="button" class="btn btn-outline-primary me-3" data-dismiss="modal"
                                                              (click)="onSelectAutopay('cancel')">Cancel</button>
                                                            </div>
                                                            <div>
                                                              <button type="button" data-dismiss="modal" class="btn btn-primary me-2"
                                                              (click)="onSelectAutopay('autopay')">Enable Autopay</button>
                                                              <button type="button" data-dismiss="modal" class="btn btn-primary"
                                                              (click)="onSelectAutopay('cardOnFile')">{{autopayFooter}}</button>
                                                            </div>
                                                          </div>
                                                        </ng-template>

                                                        <ng-template #linkedAutopay>
                                                          <div class="modal-header">
                                                            <h5 class="modal-title">Confirm</h5>
                                                            <button type="button" class="close pull-right" aria-label="Close" (click)="onClickLinkeAutopay(false)">
                                                              <span aria-hidden="true">&times;</span>
                                                            </button>
                                                          </div>
                                                          <div class="modal-body ptb24">
                                                            <p class="mb-0">Do you want to enable the same autopay for the following linked Rented Units?</p>
                                                            <ul>
                                                              @for (item of autopayLinledUnitList; track item) {
                                                                <li>{{ item.UnitNumber }}</li>
                                                              }
                                                            </ul>
                                                          </div>
                                                          <div class="modal-footer">
                                                            <button class="btn btn-outline-primary me-3" type="button" (click)="onClickLinkeAutopay(false)">No</button>
                                                            <button class="btn btn-primary" type="button" (click)="onClickLinkeAutopay(true)">Yes</button>
                                                          </div>
                                                        </ng-template>

                                                        <div class="modal fade" bsModal #showpopupforpartialPayment="bs-modal" id="showpopupforpartialPayment" tabindex="-1"
                                                          role="dialog" style="z-index: 999999999 !important">
                                                          <div class="modal-dialog modal-dialog-centered modal-md">
                                                            <div class="modal-content">
                                                              <div class="modal-header">
                                                                <h5 class="modal-title">Confirm</h5>
                                                                <button type="button" class="close pull-right" aria-label="Close" (click)="ContinueWithAutoEnrollPP()">
                                                                  <span aria-hidden="true">&times;</span>
                                                                </button>
                                                              </div>
                                                              @if (generalService.emitoAutEnrollPP) {
                                                                <div class="modal-body" >
                                                                  <p>Partial payment will remove the property protection which was auto enrolled.</p>
                                                                </div>
                                                              }
                                                              @if (generalService.emitAutoEnrolwithNoDue) {
                                                                <div class="modal-body" >
                                                                  <p>No payment towards Property Protection will remove the property protection that is auto enrolled.</p>
                                                                </div>
                                                              }
                                                              <div class="modal-footer">
                                                                <button class="btn btn-outline-primary me-3" type="button"
                                                                (click)="ContinueWithAutoEnrollPP()">No</button>
                                                                <button class="btn btn-primary" type="button" (click)="CancelAutoEnrollPP()">Yes</button>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <ng-template #OnDueDateChangeConfirmPopup>
                                                          <div class="modal-header">
                                                            <h5 class="modal-title">Confirm</h5>
                                                            <button type="button" class="close pull-right" aria-label="Close" value="1" (click)="show_OnDueDateChangeConfirmPopup.hide()">
                                                              <span aria-hidden="true" (click)="$event.stopPropagation(); $event.currentTarget.parentElement.click()">&times;</span>
                                                            </button>
                                                          </div>
                                                          <div class="modal-body">
                                                            <p>Change in Due date will not take effect if partial payment is done. Do you wish to proceed?</p>
                                                          </div>
                                                          <div class="modal-footer">
                                                            <button class="btn btn-primary" type="button" (click)="show_OnDueDateChangeConfirmPopup.hide()">No</button>
                                                            <button class="btn btn-primary" type="button" value="1" (click)="ClearFullPrepaymentOnDueDateChangeData($event)">Yes</button>
                                                          </div>
                                                        </ng-template>

<!-- Story 2.3 (FR-6, UX-DR10): alertdialog shown when a surcharge-enabled mode is added as a second row in
     a multi-mode payment. Role=alertdialog so screen readers announce it immediately; focus is placed on the
     dismiss button by BsModal; on dismiss the row reverts to unselected and focus returns to its mode selector. -->
<ng-template #surchargeMixedModeAlert>
  <div class="modal-header">
    <h5 class="modal-title" id="surchargeMixedModeAlertTitle">Payment Mode Conflict</h5>
  </div>
  <div class="modal-body" role="alertdialog" aria-labelledby="surchargeMixedModeAlertTitle" aria-describedby="surchargeMixedModeAlertDesc">
    <p id="surchargeMixedModeAlertDesc">{{surchargeMixedModeAlertText}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary"
      (click)="dismissSurchargeMixedModeAlert()">OK</button>
  </div>
</ng-template>

<ng-template #cardMismatchAlert>
  <div class="modal-header">
    <h5 class="modal-title" id="cardMismatchAlertTitle">{{cardMismatchAlertTitleText}}</h5>
  </div>
  <div class="modal-body" role="alertdialog" aria-labelledby="cardMismatchAlertTitle" aria-describedby="cardMismatchAlertDesc">
    <p id="cardMismatchAlertDesc">{{cardMismatchAlertText}}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary"
      [disabled]="isTdMismatchDismissBlocked"
      (click)="dismissCardMismatchAlert()">OK</button>
  </div>
</ng-template>
